import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';
import api from '../api';

const SocketContext = createContext();

// Use the same backend base URL for sockets from api module
// This ensures consistency and proper HTTPS handling
const SOCKET_URL = api.baseURL;

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) throw new Error('useSocket must be used within a SocketProvider');
  return context;
};

export const SocketProvider = ({ children }) => {
  const { token } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (token) {
      try {
        const newSocket = io(SOCKET_URL, {
          // Let socket.io handle transport (polling + websocket upgrade)
          auth: { token },
          withCredentials: true,
        });

        // Add error handling for WebSocket
        newSocket.on('connect_error', (error) => {
          console.warn('Socket connection error:', error.message);
        });

        newSocket.on('disconnect', (reason) => {
          console.warn('Socket disconnected:', reason);
        });

        setSocket(newSocket);

        return () => {
          if (newSocket) {
            newSocket.disconnect();
          }
        };
      } catch (error) {
        console.warn('Failed to initialize socket:', error);
      }
    }
  }, [token]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};